import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImac: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconImac"><Path d="M21.5 13.5H2.5M9.5 17.5H14.5V21.5H9.5V17.5ZM2.5 3.5H21.5V17.5H2.5V3.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconImac;
